import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CultureIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M9.21693 7.55938L12.0001 5.5714L14.7833 7.55938H9.21693ZM3.6001 9.35938L12.0001 3.35938L20.4001 9.35938H3.6001ZM11.1001 16.7998L11.1001 10.7998H12.9001V16.7998H11.1001ZM4.80005 18.2998H19.2V20.0998H4.80005V18.2998ZM15.9001 10.7998V16.7998H17.7001V10.7998H15.9001ZM6.30005 16.7998L6.30005 10.7998H8.10005V16.7998H6.30005Z"
      />
    </SvgIcon>
  );
});
